import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';

const StatItem = ({ value, label, suffix = '' }) => {
  const [count, setCount] = useState(0);

  useEffect(() => {
    const timer = setTimeout(() => {
      const increment = value / 50;
      const counter = setInterval(() => {
        setCount(prev => {
          if (prev >= value) {
            clearInterval(counter);
            return value;
          }
          return Math.min(prev + increment, value);
        });
      }, 30);
      
      return () => clearInterval(counter);
    }, 200);

    return () => clearTimeout(timer);
  }, [value]);

  return (
    <motion.div
      initial={{ opacity: 0, y: 20 }}
      whileInView={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.6 }}
      viewport={{ once: true }}
      className="text-center"
    >
      <div className="text-4xl md:text-5xl font-bold text-primary-600 mb-2">
        {Math.floor(count)}{suffix}
      </div>
      <div className="text-neutral-600 font-medium">{label}</div>
    </motion.div>
  );
};

const Stats = ({ stats, className = '' }) => {
  return (
    <div className={`grid grid-cols-2 md:grid-cols-4 gap-8 ${className}`}>
      {stats.map((stat, index) => (
        <StatItem
          key={index}
          value={stat.value}
          label={stat.label}
          suffix={stat.suffix}
        />
      ))}
    </div>
  );
};

export default Stats;